import { coreInstance, globalAxios, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    count_rider: {},
    riders_inhouse: [],
    riders_pending: [],
    riders_status: [],
    riders_deleted: [],
    rider: {}
  },
  mutations: {
    resetState(state) {
      state.riders_inhouse = [];
      state.riders_pending = [];
      state.riders_status = [];
      state.riders_deleted = [];
    },
    getRiderList(state, data) {
      state.riders_inhouse = data.filter(val => ['1', '2', '3'].includes(val.users.user_status));
      state.riders_deleted = data.filter(val => val.users.user_status == 4);
    },
    getRiderPendingList(state, data) {
      state.riders_pending = data;
    },
    getRiderDetails(state, data) {
      let ri_district_id = JSON.parse(data.user_info.ri_district_id);
      data.user_info.ri_district_id = ri_district_id;
      state.rider = data;
    },
    updateRiderDetails(state, data) {
      state.rider = data;
    },
    approveRider(state, data) {
      let index = state.riders_pending.findIndex(
        val => val.users.id == data.users.id
      );
      state.riders_pending.splice(index, 1);
    },
    deleteRider(state, data) {
      let index = state.riders_inhouse.findIndex(
        val => val.users.id == data.users.id
      );
      state.riders_inhouse.splice(index, 1);
      state.riders_inhouse.push(data);
    },
    getCountRider(state, data) {
      state.count_rider = data;
    },
    getRiderStatus(state, data) {
      if (data != null) {
        state.riders_status = [];
        data.filter((val) => {
          if (val.users.user_status == "1") {
            state.riders_status.push(true);
          } else {
            state.riders_status.push(false);
          }

        });
      }
    },
    updateRiderStatus(state, data) {
      console.log(data.status);
      if (data.status == 1) {
        state.riders_status[data.rider_id] = true;
      } else {
        state.riders_status[data.rider_id] = false;
      }
      console.log(state.riders_status[data.rider_id]);
    }

  },
  actions: {
    async getCountRider({ rootState, commit, state, dispatch }) {
      let url = rootState.api_urls.fetchRiderListBack_getCountRider;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        if (!state.count_rider.user || state.count_rider.user != res.user) {
          dispatch("getRiderPendingList");
        }
        if (
          !state.count_rider.request_money ||
          res.request_money != state.count_rider.request_money
        ) {
          dispatch("fetchCashRider/getCashReqest", {}, { root: true });
        }
        commit("getCountRider", res);
      }
    },
    async repassword({ commit, state, dispatch }, { rider_id, password }) {
      let url =
        backendVersion.version + "/Office/User/ChangePassword/" + rider_id;
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form: { password } },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return res;
      }
    },
    async deleteRider({ commit, state, dispatch }, rider_id) {
      let url = backendVersion.version + "/Office/User/" + rider_id;

      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteRider", res);
      }
    },
    async approveRider({ commit, state, dispatch }, data) {
      let url = backendVersion.version + "/Office/User/" + data.id;
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: data.data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("approveRider", res);
      }
    },
    async getRiderList({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchRiderListBack_getRiderList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getRiderList", res);
        commit("getRiderStatus", res);
        return res
      }
    },
    async getRiderPendingList({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchRiderListBack_getRiderPendingList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getRiderPendingList", res);
      }
    },
    async getRiderDetails({ commit, state, dispatch }, rider_id) {
      state.rider = {};
      let url = backendVersion.version + "/Office/User/" + rider_id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return;
      } else {
        commit("getRiderDetails", res);
        return;
      }
    },
    async updateRiderDetails({ commit, state, dispatch }, data) {
      state.rider = {};
      let url = backendVersion.version + "/Office/User/" + data.id;
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: data.data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("updateRiderDetails", res);
      }
    },
    async updateRiderStatus({ commit, dispatch }, data) {
      let url = backendVersion.version +
        "/" +
        data.province + "/backoffice/updateRiderStatus";
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: data.data },
        { root: true }
      );
      if (typeof res.msg == "boolean" && res.msg == false) {
        if (res.data == "Rider has an order") {
          return false;
        }
        return null;
      } else {
        let commitData = { rider_id: data.rider_id, data: res, status: data.data.user_status }
        commit("updateRiderStatus", commitData);
        return true;
      }

    },
    async fetchRiderBOF({ }) {
      let url = "/api/v1//Office/RiderList/";
      return globalAxios
        .get(url)
        .then((res) => {
          return res;
        })
        .catch((error) => false);
    }
  }
};
